import { GearInstance, StepperStep } from 'types';
import { WRONG_HSC_NOTIFICATION, WRONG_NUMBER_NOTIFICATION } from 'consts/wordings';
import { getHSCErrorMessage, getSimpleLengthErrorMessage } from 'utils/validators';
import {getCommonFormProps} from "./commonData";
import COUNTRY_SELECT from '../../../consts/countryCodes.json'
import { CONDITION_OPTIONS } from '../../../consts';

export const getDescriptionStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
): StepperStep => ({
  stepName: 'Description',
  onPass: async (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Next',
    ...getCommonFormProps(onPass),
    fields: [
      {
        type: 'secondTitle',
        value: 'Description',
      },
      {
        type: 'textArea',
        fieldName: 'description',
        value: instance.description,
        required: true,
        starRequiredLabel: true,
        placeholder: 'Description',
        hint: '50-2000 characters',
        label: 'Product Description',
        mode: 'middle',
        from: 50,
        to: 2000,
      },
      {
        type: 'dropdown',
        fieldName: 'condition',
        label: 'Condition',
        errorMessage: 'This field is required',
        placeholder: 'Select Product Condition',
        options: CONDITION_OPTIONS,
        value: instance.condition,
        isThin: true,
      },
      {
        type: 'textArea',
        fieldName: 'technical_specification',
        value: instance.technical_specification,
        placeholder: 'Specification',
        hint: '0-500 characters',
        label: 'Technical Specification',
        mode: 'middle',
        from: 0,
        to: 500,
      },
      ...(instance.type==='rent' ? [{
        type: 'text',
        fieldName: 'serial_number',
        errorMessage: WRONG_NUMBER_NOTIFICATION,
        placeholder: 'Serial Number',
        isThin: true,
        value: instance.serial_number,
        validator: (value) =>
          getSimpleLengthErrorMessage(value, 0, 100, 'Serial number length should be up to 100 symbols'),
      }] : [
        {
          type: 'text',
          fieldName: 'serial_number',
          errorMessage: WRONG_NUMBER_NOTIFICATION,
          placeholder: 'SKU',
          isThin: true,
          value: instance.serial_number,
          validator: (value) =>
            getSimpleLengthErrorMessage(value, 0, 100, 'SKU length should be up to 100 symbols'),
        },
        {
          type: 'text',
          fieldName: 'barcode',
          errorMessage: WRONG_NUMBER_NOTIFICATION,
          placeholder: 'Barcode (ISBN, UPC, GTIN, etc.)',
          isThin: true,
          value: instance.barcode,
          validator: (value) =>
            getSimpleLengthErrorMessage(value, 0, 100, 'Barcode length should be up to 100 symbols'),
        },
        {
          type: 'dropdown',
          options: COUNTRY_SELECT,
          placeholder: "Country of Origin",
          fieldName: 'origin_country',
          isThin: true,
          label: 'Customs Information',
          value: instance.origin_country,
          withSearch: true,
        },
        // {
        //   type: 'text',
        //   fieldName: 'hsc',
        //   errorMessage: WRONG_HSC_NOTIFICATION,
        //   placeholder: 'Harmonized System Code',
        //   isThin: true,
        //   value: instance.hsc,
        //   validator: (value) =>
        //     getHSCErrorMessage(value),
        // },
      ])
    ],
  },
});
